import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { LocalisePipe } from '../../../../../modules/pipes/localise.pipe';
import { GlobalConstantsService } from '../../../../../modules/shared/services/global-constants.service';

@Component({
  selector: 'app-dashboard-connect-bank-account-error',
  templateUrl: './dashboard-connect-bank-account-error.component.html',
  styleUrls: ['./dashboard-connect-bank-account-error.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    LocalisePipe,
  ],
})
export class DashboardConnectBankAccountErrorComponent
  implements OnInit, OnDestroy
{
  public error = '';
  public loading = false;

  constructor(
    public globalConstants: GlobalConstantsService,
    public dialogRef: MatDialogRef<DashboardConnectBankAccountErrorComponent>,
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  public connectBankAccount(): void {
    this.dialogRef.close('plaid');
  }

  public addBankAccountManually(): void {
    this.dialogRef.close('manual');
  }

  public close(): void {
    this.dialogRef.close();
  }
}
